import { Mesh, BoxGeometry, MeshStandardMaterial, TetrahedronGeometry, MeshPhongMaterial, Color } from 'three';
import PaneMaterial from '../materials/PaneMaterial.js';
import { animate } from 'motion';

export default class Pane {

    constructor(GAME) {
        this.GAME = GAME;
        this.init();
    }

    init() {
        const { width, height, depth, position } = this.GAME.config.pane;

        this.pane = new Mesh(
            new BoxGeometry(width, height, depth),
            PaneMaterial(0x86C6FF)
        );

        this.pane.position.set(position.x, position.y, position.z);
        this.pane.visible = false;

        this.pane.material.transparent = true;
        this.pane.material.opacity = 0.8;

        this.GAME.scene.add(this.pane);
    }

    randomColor() {
        // choose between two colours 0x86C6FF and 0x33455C
        const colors = [0x86C6FF, 0x33455C];
        const randomIndex = Math.floor(Math.random() * colors.length);
        const color = colors[randomIndex];
        return color;

    }

    spawnParticles(pos = undefined, count = 100, scale = 0.008) {

        if (!pos) {
            pos = this.GAME.BALL.object.position.clone();
        }

        this.GAME.SOUNDS.play('sparkle');

        for (let i = 0; i < count; i++) {
            const geom = new TetrahedronGeometry(3, 0)
            const material = new MeshStandardMaterial({
                color: this.randomColor(),
                metalness: 0,
                roughness: 0.5,
            });

            const mesh = new Mesh(geom, material)
            this.GAME.scene.add(mesh)

            mesh.visible = true
            mesh.position.copy(pos)
            mesh.scale.set(scale, scale, scale)
            const targetX = pos.x + (-1 + Math.random() * 2) * 5
            const targetY = pos.y + (-1 + Math.random() * 2) * 5
            const targetZ = pos.z + (-1 + Math.random() * 2) * 5
            const speed = 1 + Math.random() * 0.2

            animate(mesh.rotation, { x: Math.random() * 12, y: Math.random() * 12 }, { duration: speed });
            animate(mesh.scale, { x: scale * 3, y: scale * 3, z: scale * 3 }, { duration: speed });
            animate(
                mesh.position,
                { x: targetX, y: targetY, z: targetZ },
                {
                    duration: speed,
                    delay: Math.random() * 0.1,
                    easing: 'easeOut',
                    onComplete: () => {
                        this.GAME.scene.remove(mesh);
                    },
                }
            );
        }
    }

    animate() {
        this.pane.visible = true;
        this.spawnParticles();
        setTimeout(() => this.pane.visible = false, 300);
    }
}